import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class SettingService extends BaseService{
	constructor() {
		super('/Setting');
	}

	public getByIdWithObjectTypeAndId(idSetting: number, objectType: string, idTenant: number, idUser: number) {
		return super.getByIdWithResourceName(idSetting, this._resourceName + '/' + idTenant + '/' + idUser + '/' + objectType);
	}

	public getAllByFilter(filter: SettingFilter) {
		return super.getAllByFilterBase(filter);
	}

	public getGlobalFilter(filter: SettingFilter) {
		return super.getAllByFilterBase(filter, 'global');
	}

	public getTenantFilter(filter: SettingTenantFilter) {
		return super.getAllByFilterBase(filter, 'tenant');
	}
}

export class SettingTenantFilter extends BaseFilter {
	constructor(tenantIdentifier: string | null, settingIdentif: string | null ) {
		super();

		this._tenant = tenantIdentifier;
		this._settingIdentif = settingIdentif;
	}

	private _tenant?: string | null;
	private _settingIdentif?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._tenant != null ? { Tenant: this._tenant } : {}),
			(this._settingIdentif != null ? { Setting: this._settingIdentif } : {})
		);

		return data;
	};
}

export class SettingFilter extends BaseFilter{
	constructor(identifierModule: string | null, isSettingGlobal?: boolean | null, isSettingTenant?: boolean | null, isSettingUser?: boolean | null, idTenant?: number | null
		, idUser?: number | null, identifierListString?: string | null) {
		super();

		this._identifierModule = identifierModule;
		this._isSettingGlobal = isSettingGlobal;
		this._isSettingTenant = isSettingTenant;
		this._isSettingUser = isSettingUser;
		this._idTenant = idTenant;
		this._idUser = idUser;
		this._identifierListString = identifierListString;
	}

	private _identifierModule?: string | null;
	private _isSettingGlobal?: boolean | null;
	private _isSettingTenant?: boolean | null;
	private _isSettingUser?: boolean | null;
	private _idTenant?: number | null;
	private _idUser?: number | null;
	private _identifierListString?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._identifierModule != null  ? { IdentifierModule: this._identifierModule } : {}),
			(this._isSettingGlobal != null  ? { IsSettingGlobal: this._isSettingGlobal } : {}),
			(this._isSettingTenant != null  ? { IsSettingTenant: this._isSettingTenant } : {}),
			(this._isSettingUser != null ? { IsSettingUser: this._isSettingUser } : {}),
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._idUser != null ? { IdUser: this._idUser } : {}),
			(this._identifierListString != null ? { IdentifierListString: this._identifierListString } : {})
		);

		return data;
	};
}